export function getScrollableParent(element: HTMLElement | null | undefined) {
  let parent = element?.parentElement;

  while (parent) {
    const overflowY = window.getComputedStyle(parent).overflowY;

    if (/(auto|scroll|overlay)/.test(overflowY) && parent.scrollHeight > parent.clientHeight) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return null;
}

export function scrollToElementWithOffset(element: HTMLElement | null | undefined, offset = 0) {
  const container = getScrollableParent(element);

  if (!container) {
    return;
  }

  const containerRect = container.getBoundingClientRect();
  const elementRect = element!.getBoundingClientRect();

  const scrollTop = container.scrollTop + (elementRect.top - containerRect.top) - offset;

  container.scrollTo({
    top: scrollTop,
    behavior: 'smooth',
  });
}
